import { withCompInfo } from '../../core/withCompInfo'
import {
	GridDefinition,
	GridProps,
	GridProperties,
	GridCSSVars,
	GridPagination,
	GridSkin,
	GridHeaderColumn,
} from './types'

const skinToHeaderColumnMap: Record<GridSkin, GridHeaderColumn> = {
	GridSkin: 'none',
	GridLeftHeaderSkin: 'first',
	GridRightHeaderSkin: 'last',
}

const mapPagination = ({ type, rowsPerPage }: GridProperties['pagination']): GridPagination => ({
	type,
	rowsPerPage,
})

export const props = withCompInfo<GridProps, GridDefinition>(
	['skin', 'compProps', 'compData', 'topology'],
	({
		skin,
		compProps: { columns, showHeader, pagination, userSelectionType, dateFormat, linkTarget, columnLayout },
		compData: { rows, dataSource },
		topology: { staticMediaUrl },
	}) => ({
		dataSource: dataSource.type,
		columns,
		rows,
		headerColumn: skinToHeaderColumnMap[skin],
		showHeader,
		pagination: mapPagination(pagination),
		userSelectionType,
		dateFormat,
		linkTarget,
		columnLayout,
		staticMediaUrl,
	})
)

export const css = withCompInfo<GridCSSVars, GridDefinition>(
	['compProps', 'styleProperties'],
	({
		compProps: { headerHeight, rowHeight, heightLayout, horizontalAlignment },
		styleProperties: { cellPadding },
	}) => ({
		...(heightLayout === 'auto' && { height: 'auto' }),
		'--headerHeight': `${headerHeight}px`,
		'--rowHeight': `${rowHeight}px`,
		'--horizontalAlignment': horizontalAlignment,
		...(horizontalAlignment === 'left' && { '--cellPaddingLeft': cellPadding }),
		...(horizontalAlignment === 'right' && { '--cellPaddingRight': cellPadding }),
	})
)
